import { Routes } from '@angular/router';
import { menuConfig } from './config/menu.config';
import { RoleGuard } from '@shared/guards/role-access.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: menuConfig.default,
        pathMatch: 'full',
      },
      {
        path: 'revenue',
        loadComponent: () =>
          import('./pages/revenue-management/revenue-management.component').then((m) => m.RevenueManagementComponent),
        canActivate: [
          RoleGuard
        ],
        data: {
          roles: [
            'ADMIN',
            'STAFF',
          ],
        },
      },
      {
        path: 'user',
        loadComponent: () =>
          import('./pages/user/user.component').then((m) => m.UserComponent),
        canActivate: [
          RoleGuard
        ],
        data: {
          roles: [
            'ADMIN',
          ],
        },
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import(
        './layout/components/error-notfound/error-notfound.component'
      ).then((m) => m.ErrorNotfoundComponent),
  },
];
